import React from 'react';
import ExamMetrics from '../ExamMetrics';

function ExamMetricsList() {
  return (
    <div className="main-content main-content--block">
      <ExamMetrics />
    </div>
  );
}

export default ExamMetricsList;
